export default () => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& #lottie': {
      width: '60px !important',
      height: '60px !important'
    }
  }
});